import { render, staticRenderFns } from "./VideoBornH2P.vue?vue&type=template&id=d5b05162&scoped=true&"
import script from "./VideoBornH2P.vue?vue&type=script&lang=js&"
export * from "./VideoBornH2P.vue?vue&type=script&lang=js&"
import style0 from "./VideoBornH2P.vue?vue&type=style&index=0&id=d5b05162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b05162",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VHover,VRow})
